import { BREAKPOINT_TABLET, CARD_INNER_PADDING } from "constants/constants";
import { css } from "styled-components/macro";

export const DASHBOARD_CARD_PROPS = {
  showTitleBorder: false,
  shouldCenterTitle: true,
  collapsible: true,
  isFullHeight: false,
};
export const TRENDS_CARD_PROPS = {
  showTitleBorder: false,
  shouldCenterTitle: true,
  collapsible: true,
  isFullHeight: false,
};
export const PNL_SUMMARY_CHART_CARD_CSS = css`
  .cardContent {
    padding-top: 36px;
    padding-bottom: 36px;
    padding-left: ${CARD_INNER_PADDING}px;
    padding-right: ${CARD_INNER_PADDING}px;
    @media (min-width: ${BREAKPOINT_TABLET}px) {
      padding-left: 46px;
      padding-right: 46px;
    }
  }
  position: relative;
`;

/** create a scale based on width that starts at 0.6, and goes to 1 at 2560px window width */
export function getScaleFromWidthForLargeScreens(width: number) {
  return width / (2560 / 2) - 0.18125;
}
